<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-21 16:35:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-29 16:09:00
 * @FilePath: 
 * @Description: 已支付餐品的订单详情
-->
<template>
  <div class="payed_order_info_page">
    <div class="payed_foods_con payed_foods_list">
      <ul>
        <li
          v-for="(item, index) in orderInfo.Details"
          :key="index"
          class="van-hairline--bottom"
        >
          <van-card
            :desc="item.Remark"
            :title="item.ProductName"
            :thumb="item.ProductImage ? item.ProductImage : $root.defaultImg"
            :num="item.Quantity"
          >
            <template #title>
              <van-row type="flex" justify="space-between" gutter="20">
                <p>{{ item.ProductName }}</p>
                <p class="c-orange">￥{{ item.Price }}</p>
              </van-row>
            </template>
            <template #tags v-if="item.mealNameStr">
              <div class="meal_desc_con">
                <p>{{ item.mealNameStr }}</p>
              </div>
            </template>
          </van-card>
        </li>
      </ul>

      <van-row type="flex" justify="end">
        <p class="small_price_con c-lightgrey">
          共{{ allGoodsNum }}份餐品 <span class="c-main-txt">合计：</span
          ><i class="c-orange">￥{{ orderInfo.OrigMoney }}</i>
        </p>
      </van-row>
    </div>
    <div class="payed_foods_info">
      <div class="payed_foods_info_item">
        <p>订单编号</p>
        <p>{{ orderInfo.Id }}</p>
      </div>
      <div class="payed_foods_info_item">
        <p>创建时间</p>
        <p>{{ orderInfo.CreateTime }}</p>
      </div>
      <div class="payed_foods_info_item">
        <p>支付时间</p>
        <p>{{ orderInfo.PayTime }}</p>
      </div>
      <div class="payed_foods_info_item">
        <p>支付方式</p>
        <p>
          {{ orderInfo.PayType
          }}<span v-if="orderInfo.KeyCode">{{
            " 手牌号：" + orderInfo.KeyCode
          }}</span>
        </p>
      </div>
      <div class="payed_foods_info_item">
        <p>订单备注</p>
        <p>{{ orderInfo.Remark }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { handleLocalStorage } from "@/utils";
export default {
  name: "FoodOrderInfo",
  props: {},
  data() {
    return {
      orderInfo: {
        Details: [],
      },
    };
  },
  computed: {
    allGoodsNum() {
      let all_num = 0;
      this.orderInfo.Details.forEach((item) => {
        all_num += item.Quantity;
      });
      return all_num;
    },
  },
  components: {},
  created() {
    const foodItem = handleLocalStorage.get("foodItemInfo");
    if (foodItem) {
      foodItem.Details.forEach((item) => {
        if (item.GoodsServiceId == 6 && item.PackageGoodsJson) {
          const mealList = JSON.parse(item.PackageGoodsJson);
          let mealNameArr = [];
          mealList.forEach((mItem) => {
            if (mItem.NumberCount > 0) {
              mealNameArr.push(
                (mItem.GoodsName || "") + "X" + mItem.NumberCount
              );
            }
          });
          item.mealNameStr = mealNameArr.join("+");
        }
      });
      this.orderInfo = foodItem;
    }
  },
  mounted() {},
  methods: {
    handleSetDesc(item) {
      let desc = item.Specification || "";
      return item.Remark ? desc + " " + item.Remark : desc;
    },
  },
};
</script>
<style scoped lang="scss">
.payed_order_info_page {
  @include border-box(30px);
  height: 100vh;
}
.payed_foods_con {
  @include white-box-radius(20px);
  .small_price_con {
    padding: 20px 0;
    font-size: 24px;
  }
  .van-card {
    padding: 10px 0;
  }
}
.payed_foods_info {
  @include white-box-radius(30px);
  margin-top: 12px;
}
.payed_foods_info_item {
  display: flex;
  justify-content: space-between;
  color: #333;
  margin-bottom: 25px;
  font-size: 24px;
  p:first-child {
    color: #999;
  }
}
.meal_desc_con {
  display: flex;
  align-items: center;
  margin: 10px 0;
  p {
    flex: 1;
    font-size: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  background: #ebedf0;

  padding: 6px 8px;
  border-radius: 3px;
}
</style>
